import { gql } from '@apollo/client';

export const supplierQuery = gql`
  query ($personId: ID!) {
    getSupplier(personId: $personId) {
      idFDEm
      personId
      personName
      cnpj
      riskClassification
      annualBilling
      creditLimit
      socialCapital
      minApprovalSignatures
      constitutionDate
      companyType
      companySize
      receitaRegistrationStatus
    }
  }
`;
